module.exports = __webpack_public_path__ + "static/img/17.aa6f38c3.png";